module.exports = __webpack_public_path__ + "img/38-3.44646718.jpg";